<script setup lang="ts">
// @ts-nocheck
import { ArrowLeft24Regular } from '@vicons/fluent';
import { RouterLink } from 'vue-router';

defineOptions({
  inheritAttrs: false
})

const props = defineProps({
  ...RouterLink.props,
  inactiveClass: String,
  raw: Boolean,
  backArrow: Boolean
})

const isExternalLink = computed(() => typeof props.to === 'string' && (props.to.startsWith('http') || props.to.startsWith('mailto')))
</script>

<template>
  <a v-if="isExternalLink" v-bind="$attrs" :href="to" target="_blank" class="text-indigo-900 dark:text-indigo-200 font-bold hover:underline">
    <slot />
  </a>

  <router-link
    v-else
    v-bind="$props"
    :to="$props.to"
    custom
    v-slot="{ isActive, href, navigate }"
  >
    <div
      v-if="props.raw"
      v-bind="$attrs"
      :href="href"
      @click="navigate"
      class="flex items-center cursor-pointer!"
    >
      <slot />
    </div>
    <a
      v-else
      v-bind="$attrs"
      :href="href"
      @click="navigate"
      :class="isActive ? activeClass : inactiveClass"
      class="text-indigo-800 dark:text-indigo-200 font-bold flex items-center gap-1 leading-none hover:underline"
    >
      <n-icon v-if="props.backArrow">
        <ArrowLeft24Regular />
      </n-icon>
      <slot />
    </a>
  </router-link>
</template>